import flexPDF from "../../../../assets/images/cheatsheets/flex.pdf";
import flexPNG from "../../../../assets/images/cheatsheets/flex.png";
import gridPDF from "../../../../assets/images/cheatsheets/grid.pdf";
import gridPNG from "../../../../assets/images/cheatsheets/grid.png";
import anchorPDF from "../../../../assets/images/cheatsheets/anchor.pdf";
import anchorPNG from "../../../../assets/images/cheatsheets/anchor.png";
import invokerPDF from "../../../../assets/images/cheatsheets/invoker.pdf";
import invokerPNG from "../../../../assets/images/cheatsheets/invoker.png";
import CSSday1 from "../../../../assets/images/blogs/cheatsheets/cssday-2026-27.jpg";
import CSSday2 from "../../../../assets/images/blogs/cheatsheets/cssday-2026-100.jpg";
import CSSday3 from "../../../../assets/images/blogs/cheatsheets/booth.webp";
import * as React from 'react';
export default {
  flexPDF,
  flexPNG,
  gridPDF,
  gridPNG,
  anchorPDF,
  anchorPNG,
  invokerPDF,
  invokerPNG,
  CSSday1,
  CSSday2,
  CSSday3,
  React
};